"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Check = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _svgs = require("../../svgs");

var _Box = require("../Box");

var _tokens = require("./tokens");

var _excluded = ["disabled", "selected"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Toggeable check mark */
var Check = function Check(_ref) {
  var disabled = _ref.disabled,
      selected = _ref.selected,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    mr: 1,
    border: "1px solid",
    disabled: disabled,
    selected: selected
  }, rest), /*#__PURE__*/_react.default.createElement(_svgs.CheckIcon, {
    "aria-hidden": true,
    fill: "currentColor"
  }));
};

exports.Check = Check;
Check.displayName = "Check";
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Check__Container",
  componentId: "mkx5fy-0"
})(["width:20px;height:20px;display:flex;align-items:center;justify-content:center;transition:background-color 0.25s,border-color 0.25s,color 0.25s;", ";"], function (props) {
  var mode = function () {
    switch (true) {
      case props.focus:
        return _tokens.CHECK_STATES.focus;

      case props.hover:
        return _tokens.CHECK_STATES.hover;

      case props.error:
        return _tokens.CHECK_STATES.error;

      case props.disabled:
        return _tokens.CHECK_STATES.disabled;

      default:
        return _tokens.CHECK_STATES.default;
    }
  }();

  return props.selected ? mode.selected : mode.resting;
});
//# sourceMappingURL=Check.js.map